import { ChangeDetectionStrategy, Component } from '@angular/core';

/**
 * This class represents the main application component.
 */
@Component({
  selector: 'lh-no-access',
  templateUrl: 'no-access.component.html',
  styleUrls: ['no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default, // Everything else uses OnPush
})
export class NoAccessComponent {}
